import { Component } from '@angular/core';

@Component({
    selector: 'tgrid-appendix-page',
    templateUrl: './appendix-page.component.html',
    styleUrls: ['./appendix-page.component.scss'],
})
export class AppendixPageComponent { 
}